import React from 'react'
import "./Headline.css";
const Headline = ({title}) => {
  return (
    <div style={{width: "100%", height: "5.5%", backgroundColor: "#2a3042", display: "flex", alignContent: "center", color: "white", fontSize: "20px"}}>
      <p style={{marginLeft: "1%",marginTop: "1%"}}>{title}</p>
    </div>
  )
}

export default Headline
